import { useQuery } from '@tanstack/react-query';
import { startAinavioAssistantChat } from '@/api/ainavioAssistant/startAinavioAssistantChat';

export const useGetAinavioAssistantIframe = (enabled: boolean) => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['ainavio-assistant-iframe-url'],
    queryFn: startAinavioAssistantChat,
    enabled: enabled,
  });

  return {
    initializing: isLoading || isFetching || isError,
    iframeUrl: data?.iframeUrl,
  };
};
